module.exports = __webpack_public_path__ + "static/media/3_Jens_Winter_Zertifikate.dfe7a2e9.jpg";